// extracted by mini-css-extract-plugin
var _1 = "ApplicantProfileDocumentsMockTable-moduleApplicantProfileDocumentsMockTable__xUPwJ";
var _2 = "ApplicantProfileDocumentsMockTable-moduleemptyState__Q3N9g ApplicantProfileDocumentsMockTable-moduleApplicantProfileDocumentsMockTable__xUPwJ";
var _3 = "ApplicantProfileDocumentsMockTable-moduleoutstanding__PE3xw";
var _4 = "ApplicantProfileDocumentsMockTable-modulerow__BRqCr TableComponent-modulerow__xPAo4";
var _5 = "ApplicantProfileDocumentsMockTable-moduletable__OLZyZ TableComponent-moduleTable__mhqNq";
export { _1 as "ApplicantProfileDocumentsMockTable", _2 as "emptyState", _3 as "outstanding", _4 as "row", _5 as "table" }
